import * as React from "react";
import { useMemo } from "react";
import { Nav } from "components/bootstrap";
import usePluginEntities from "hooks/usePluginEntities";
import NavigationItem from "components/navigation/NavigationItem";
import sortNavigationItems from "components/navigation/util/sortNavigationItems";
import mergeNavigationItems from "./util/mergeNavigationItems";
const HIDDEN_NAV = /* @__PURE__ */ new Set(["alerts", "enterprise", "security", "\u544A\u8B66", "\u4F01\u4E1A\u7248", "\u5B89\u5168"]);
const useNavigationItems = () => {
  const allNavigationItems = usePluginEntities("navigation");
  const navigationItems = useMemo(() => mergeNavigationItems(allNavigationItems), [allNavigationItems]);
  return useMemo(
    () => sortNavigationItems(navigationItems).filter(
      (item) => !HIDDEN_NAV.has((item.description || "").toLowerCase())
    ),
    [navigationItems]
  );
};
const MainNavbar = ({ pathname }) => {
  const navigationItems = useNavigationItems();
  return /* @__PURE__ */ React.createElement(Nav, { className: "navbar-main" }, navigationItems.map((navigationItem) => /* @__PURE__ */ React.createElement(NavigationItem, { navigationItem, pathname, key: navigationItem.description })));
};
export default MainNavbar;
